document.addEventListener('DOMContentLoaded', () => {
    const LEGACY_INLINE_ADDONS_OPT_IN_SELECTOR = '[data-inline-addons-enabled="true"], [data-legacy-inline-addons-enabled="true"]';

    function valueOrEmpty(value) {
        return value == null ? '' : value.toString().trim();
    }

    function legacyInlineAddonsEnabled(...nodes) {
        return nodes.some((node) => {
            if (!node) return false;

            if (node.nodeType === Node.ELEMENT_NODE && typeof node.closest === 'function') {
                return Boolean(node.closest(LEGACY_INLINE_ADDONS_OPT_IN_SELECTOR));
            }

            if (typeof node.querySelector === 'function') {
                return Boolean(node.querySelector(LEGACY_INLINE_ADDONS_OPT_IN_SELECTOR));
            }

            return false;
        });
    }

    function selectedSellingPlanId(form, formElement) {
        const submittedValues = typeof form.getAll === 'function'
            ? form.getAll('selling_plan')
            : [form.get('selling_plan')];
        const formValue = submittedValues.map(valueOrEmpty).find(Boolean) || '';
        if (formValue) return formValue;

        if (!formElement) return '';

        const checkedInput = formElement.querySelector('input[name="selling_plan"]:checked:not(:disabled)');
        const checkedValue = valueOrEmpty(checkedInput?.value);
        if (checkedValue) return checkedValue;

        const select = formElement.querySelector('select[name="selling_plan"]:not(:disabled)');
        const selectValue = valueOrEmpty(select?.value);
        if (selectValue) return selectValue;

        return '';
    }

    // 1. The Universal Evaluator (Intercepts native Add-to-Cart)
    document.addEventListener('product-form:cart:request', async (event) => {
        const { form, cartBefore, resolve, reject } = event.detail;

        const formElement =
            event.target.querySelector?.('form') ||
            event.target.closest?.('form') ||
            event.target.form ||
            null;

        const productScope =
            formElement?.closest?.('[data-product-id], #MainContent, [id^="shopify-section-"]') ||
            event.target.closest?.('[data-product-id], #MainContent, [id^="shopify-section-"]') ||
            document;

        if (!legacyInlineAddonsEnabled(formElement, productScope)) return;

        // Find active add-ons. Prefer form scope; fall back to nearest product scope.
        let addonRows = formElement?.querySelectorAll('.js-custom-inline-addon-row');
        if (!addonRows || addonRows.length === 0) {
            addonRows = productScope.querySelectorAll('.js-custom-inline-addon-row');
        }

        const plusUps = [];
        addonRows.forEach(row => {
            const input = row.querySelector('.element-quantity-selector__input');
            const qty = parseInt(input ? input.value : 0, 10);
            const baseQty = parseInt(row.dataset.baseQty || 0, 10);
            const delta = qty - baseQty;
            const variantId = row.dataset.variantId;

            // Only send the delta above the base box quantity as a plus-up
            if (delta > 0 && variantId && variantId !== "") {
                plusUps.push({ id: variantId, quantity: delta });
            }
        });

        // Only the positive inline add-on delta needs this custom bulk request.
        // Let Appstle and the theme handle ordinary one-time/subscription submits.
        if (plusUps.length === 0) return;

        const sellingPlanId = selectedSellingPlanId(form, formElement);

        // We must intervene. Halt the native request!
        event.preventDefault();

        try {
            const baseVariantId = form.get('id');
            const baseQty = parseInt(form.get('quantity') || 1, 10);

            // Preserve existing hidden properties (Appstle natively injects some here)
            let baseProperties = {};
            for (let [key, value] of form.entries()) {
                if (key.startsWith('properties[') && value) {
                    const propName = key.match(/properties\[(.*?)\]/)[1];
                    baseProperties[propName] = value;
                }
            }

            let subGroupId = self.crypto.randomUUID ? self.crypto.randomUUID() : 'id-' + Date.now();
            let baseRole = plusUps.length > 0 ? 'base_box' : 'genesis';

            // Reuse an existing subscription group where possible. Shopify only stacks
            // line items when variant, selling plan, and properties are identical.
            if (sellingPlanId && cartBefore && cartBefore.items) {
                const sameSellingPlanItems = cartBefore.items.filter(item =>
                    item.selling_plan_allocation?.selling_plan?.id?.toString() === sellingPlanId.toString()
                );

                const existingSameVariant = sameSellingPlanItems.find(item =>
                    item.variant_id?.toString() === baseVariantId?.toString() &&
                    item.properties?.['_role'] !== 'plus_up'
                );

                if (existingSameVariant?.properties?.['_sub_group_id']) {
                    subGroupId = existingSameVariant.properties['_sub_group_id'];
                    baseRole = existingSameVariant.properties['_role'] || baseRole;
                    baseProperties = { ...existingSameVariant.properties };
                } else {
                    const existingGroupAnchor = sameSellingPlanItems.find(item =>
                        item.properties?.['_sub_group_id'] &&
                        item.properties?.['_role'] !== 'plus_up'
                    );

                    if (existingGroupAnchor?.properties?.['_sub_group_id']) {
                        subGroupId = existingGroupAnchor.properties['_sub_group_id'];
                        baseRole = 'plus_up'; // Demote from genesis to standard plus-up
                    }
                }
            } else if (!sellingPlanId) {
                baseRole = 'one_time';
            }

            const itemsPayload = [];

            // A. Add Base/Anchor Item
            itemsPayload.push({
                id: baseVariantId,
                quantity: baseQty,
                selling_plan: sellingPlanId || undefined,
                properties: {
                    ...baseProperties,
                    ...((baseRole !== 'one_time' || plusUps.length > 0) ? {
                        '_sub_group_id': subGroupId,
                        '_role': baseRole,
                        '_group_name': sellingPlanId ? 'Subscription Group' : 'Grouped Items'
                    } : {})
                }
            });

            // B. Add Plus-Ups (Qty scaled automatically by Base Qty)
            plusUps.forEach(addon => {
                itemsPayload.push({
                    id: addon.id,
                    quantity: addon.quantity * baseQty,
                    selling_plan: sellingPlanId || undefined,
                    properties: {
                        '_sub_group_id': subGroupId,
                        '_role': 'plus_up',
                        '_group_name': 'Plus-Up Addon'
                    }
                });
            });

            // Execute Bulk Add — XHR bypasses Appstle's fetch interceptor
            const cartAddUrl = `${window.Shopify.routes.root}cart/add.js`;
            const bulkBody = JSON.stringify({ items: itemsPayload });

            const responseData = await new Promise((fetchResolve, fetchReject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', cartAddUrl);
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.setRequestHeader('Accept', 'application/json');
                xhr.onload = () => {
                    const data = JSON.parse(xhr.responseText);
                    if (xhr.status >= 400) fetchReject(data);
                    else fetchResolve(data);
                };
                xhr.onerror = () => fetchReject(new Error('Network error'));
                xhr.send(bulkBody);
            });

            // NATIVE BRILLIANCE: Hand control back to Archetype's component so it triggers the drawer natively!
            resolve(responseData);

        } catch (error) {
            reject(error);
        }
    });


    // 2. The Cascading Delete "Garbage Collector"
    // Listens to the theme's native cart updates. Finds orphaned plus_ups whose parent was removed.
    document.addEventListener('cart:updated', async (event) => {
        if (!legacyInlineAddonsEnabled(document)) return;

        const cart = event.detail.cart;
        if (!cart || !cart.items) return;

        // Map all alive group UUIDs that still have an active anchor
        const aliveGroups = new Set();
        cart.items.forEach(item => {
            const role = item.properties?.['_role'];
            if (role === 'base_box' || role === 'genesis' || role === 'one_time') {
                const groupId = item.properties['_sub_group_id'];
                if (groupId) aliveGroups.add(groupId);
            }
        });

        const updates = {};
        let needsCleanup = false;

        // Target orphans (plus_ups whose anchor is gone) for deletion
        cart.items.forEach(item => {
            if (item.properties?.['_role'] === 'plus_up') {
                const groupId = item.properties['_sub_group_id'];
                if (groupId && !aliveGroups.has(groupId)) {
                    updates[item.key] = 0;
                    needsCleanup = true;
                }
            }
        });

        if (needsCleanup) {
            // Silently blast orphans
            await fetch(`${window.Shopify.routes.root}cart/update.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({ updates })
            });
            // Fire the native theme dev-tool event to refresh the UI drawer again!
            document.dispatchEvent(new CustomEvent('cart:build'));
        }
    });
});
